import * as actions from './actions';
import { tracPageInitialState } from './initial-state';
import { TracPageState } from './state';
import { TracPageActions } from './action-creators';
import _ from 'lodash';

const tracPageReducer = (
  state: TracPageState = tracPageInitialState,
  action: TracPageActions
): TracPageState => {
  switch (action.type) {
    case actions.GET_TRAC_LINK_DSPS_SUCCESS:
      return {
        ...state,
        dspsMap: action.dspsMap,
      };
    case actions.UPDATE_TRAC_PAGE_FIELD: {
      if (action.pageType === 'tracpage') {
        const { field, value, config } = action;
        const stateKey = config?.updateDraft ? 'artistPageDraft' : 'artistPage';

        const isCurrentValue = _.isEqual(value, state[stateKey][field]);
        if (isCurrentValue) return state;

        let trackChangesFields = {
          isArtistPageChanged: true,
          artistPageChangesMap: state.artistPageChangesMap,
          artistPageChanges: state.artistPageChanges,
        };

        if (config?.updateDraft) {
          let { artistPageChangesMap } = state;

          const historyValue = artistPageChangesMap[field];

          if (!historyValue) {
            artistPageChangesMap = {
              ...artistPageChangesMap,
              [field]: state.artistPage[field],
            };
          }

          if (historyValue && _.isEqual(value, historyValue)) {
            artistPageChangesMap = Object.fromEntries(
              Object.entries(artistPageChangesMap).filter(
                ([key]) => key !== field
              )
            );
          }

          trackChangesFields = {
            ...trackChangesFields,
            artistPageChangesMap,
            artistPageChanges: Object.keys(artistPageChangesMap).length,
          };
        }

        return {
          ...state,
          [stateKey]: {
            ...state[stateKey],
            [field]: value,
          },
          ...trackChangesFields,
        };
      }

      return {
        ...state,
        trackLinks: {
          ...state.trackLinks,
          editor: {
            ...state.trackLinks.editor,
            [action.field]: action.value,
          },
        },
      };
    }

    case actions.UPDATE_TRAC_PAGE_DATA_FIELD: {
      if (action.pageType === 'tracpage') {
        const { field, value, config } = action;
        const stateKey = config?.updateDraft ? 'artistPageDraft' : 'artistPage';

        const isCurrentValue = _.isEqual(value, state[stateKey].data[field]);
        if (isCurrentValue) return state;

        let trackChangesFields = {
          isArtistPageChanged: true,
          artistPageChangesMap: state.artistPageChangesMap,
          artistPageChanges: state.artistPageChanges,
        };

        if (config?.updateDraft) {
          let { artistPageChangesMap } = state;

          const historyValue = artistPageChangesMap[field];

          if (!historyValue) {
            artistPageChangesMap = {
              ...artistPageChangesMap,
              [field]: state.artistPage.data[field],
            };
          }

          if (historyValue && _.isEqual(value, historyValue)) {
            artistPageChangesMap = Object.fromEntries(
              Object.entries(artistPageChangesMap).filter(
                ([key]) => key !== field
              )
            );
          }

          trackChangesFields = {
            ...trackChangesFields,
            artistPageChangesMap,
            artistPageChanges: Object.keys(artistPageChangesMap).length,
          };
        }

        return {
          ...state,
          [stateKey]: {
            ...state[stateKey],
            data: {
              ...state[stateKey].data,
              [field]: value,
            },
          },
          ...trackChangesFields,
        };
      }

      return {
        ...state,
        trackLinks: {
          ...state.trackLinks,
          editor: {
            ...state.trackLinks.editor,
            data: {
              ...state.trackLinks.editor.data,
              [action.field]: action.value,
            },
          },
        },
      };
    }

    case actions.GET_TRAC_PAGE_SUCCESS: {
      return {
        ...state,
        artistPage: {
          ...action.tracPage,
        },
        ...(action.draft ?? { artistPageDraft: action.tracPage }),
      };
    }

    case actions.LIST_TRAC_LINKS: {
      return {
        ...state,
        trackLinks: {
          ...state.trackLinks,
          list: [],
        },
      };
    }

    case actions.LIST_TRAC_LINKS_SUCCESS: {
      return {
        ...state,
        trackLinks: {
          ...state.trackLinks,
          list: action.tracLinks,
        },
      };
    }

    case actions.CREATE_TRAC_LINK_SUCCESS: {
      return {
        ...state,
        trackLinks: {
          ...state.trackLinks,
          editor: action.tracLink,
        },
      };
    }

    case actions.DELETE_TRAC_LINK_SUCCESS: {
      return {
        ...state,
        trackLinks: {
          ...state.trackLinks,
          list: state.trackLinks.list.filter((t) => t.id !== action.tracLinkId),
        },
      };
    }

    case actions.SELECT_TRAC_LINK: {
      return {
        ...state,
        trackLinks: {
          ...state.trackLinks,
          editor: {
            ...action.tracLink,
          },
        },
      };
    }
    case actions.SET_ARTIST_PREVIEW: {
      return {
        ...state,
        artistPreview: action.value,
      };
    }
    case actions.UPDATE_TRAC_PAGE_SUCCESS: {
      return {
        ...state,
        isArtistPageChanged: false,
        artistPageChanges: 0,
        artistPageChangesMap: {},
      };
    }

    default:
      return state;
  }
};

export default tracPageReducer;
